import {AfterViewInit, ViewChild, Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ImageCroppedEvent, ImageTransform, LoadedImage} from "ngx-image-cropper";

@Component({
    selector: 'app-images-box',
    templateUrl: './images-box.component.html',
    styleUrls: ['./images-box.component.scss'],
    standalone: false
})
export class ImagesBoxComponent implements OnInit, AfterViewInit  {
  readonly outputImageSize = 400;
  @Input() imageSelected:any;
  @Output() imageSelectedChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();

  @Input()
  keyIndex!:number;

  @Input() selectClass: string = 'main-class';
  @Input() avatarSize = 112;
  @Input() editable = true;
  @ViewChild('imageBoxInput') imageButton:any;

  @Input()
  title!: string;
  constructor() {
  }
  ngAfterViewInit(){


  }
  ngOnInit(): void {
  }
  imageChangedEvent: any = '';
  croppedImage: any = undefined;
  cropperOpen: boolean = false;
  isCompressing = false;
  zoom = 1;
  transform: ImageTransform = { scale: 1 };
  imageOrientation: 'portrait' | 'landscape' | 'square' = 'square';
  imageAspectRatio = '1 / 1';

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.setZoom(1);
    this.cropperOpen = true;

  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded(image: LoadedImage) {
    const source: any = image?.original;
    const width = Number(source?.size?.width ?? source?.image?.naturalWidth ?? 1);
    const height = Number(source?.size?.height ?? source?.image?.naturalHeight ?? 1);
    this.imageAspectRatio = `${width} / ${height}`;
    this.imageOrientation = height > width ? 'portrait' : width > height ? 'landscape' : 'square';
  }
  cropperReady() {
    // cropper ready

  }
  loadImageFailed() {
    // show message
  }
  openImageLoader(){
    if (!this.editable) return;
    this.imageButton.nativeElement.click();
  }

  onZoomChange(value: string | number): void {
    this.setZoom(Number(value));
  }

  zoomIn(): void { this.setZoom(this.zoom + 0.1); }
  zoomOut(): void { this.setZoom(this.zoom - 0.1); }

  private setZoom(value: number): void {
    this.zoom = Math.min(3, Math.max(1, Number(value.toFixed(1))));
    this.transform = { ...this.transform, scale: this.zoom };
  }

  convertBlobToBase64 = (blob:any) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });


  convertDataUrlToBlob(dataURI:any) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], {type: mimeString});
    return blob;

  }

  async cropImage(): Promise<void> {
    if (!this.croppedImage || this.isCompressing) return;

    this.isCompressing = true;
    try {
      // ngx-image-cropper already creates a resized 400x400 JPEG using the
      // quality configured in the template. A second global compressor caused
      // the application to fail during module initialization.
      this.onChange.emit(this.croppedImage);
      this.imageSelectedChange.emit(this.croppedImage);
      this.cropperOpen = false;
    } finally {
      this.isCompressing = false;
    }
  }


  closeWindow() {
    if (this.isCompressing) return;
    this.cropperOpen = false;
    this.croppedImage = undefined;
  }
}
